import { render } from "./app-header.vue?vue&type=template&id=5cacc109"
import script from "./app-header.js?vue&type=script&lang=js&external"
export * from "./app-header.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__